import { createQueryKeys } from '@lukemorales/query-key-factory';

import type { Api } from '@/externals/corner-logis/Swagger';

import { CornerLogis } from '../../helpers';

export const 코너로지스_주문_쿼리 = createQueryKeys('corner-logis-order', {
  주문_목록_조회: ({ shopID, query }: { shopID: string; query: Api.GetOrderList1.RequestQuery }) => ({
    queryKey: [shopID, query] as const,
    queryFn: () => {
      return CornerLogis.proxy<Api.GetOrderList1.ResponseBody>({
        method: 'GET',
        path: '/api/v1/order/getOrders',
        params: query,
        shopID,
      });
    },
  }),
});
